import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty } from 'lodash';
import {
  BaseCard,
  BaseCardBody,
  BaseCardHeader,
} from '@unite-us/app-components';
import ServiceProviderListItem from './ServiceProviderListItem';

const ServiceProvidersList = ({ providers, header }) => {
  const emptyProviders = (
    <div className="empty-providers">No Organizations Found</div>
  );

  return (
    <BaseCard className="service-provider-list">
      <BaseCardHeader title={header} />
      <BaseCardBody withPadding className="service-provider-list__body">
        <ul className="service-provider-list__list list-unstyled">
          {
            isEmpty(providers) ? emptyProviders : providers.map((provider = {}) => (
              <li
                className="service-provider-list__list-item"
                key={provider.id}
              >
                <ServiceProviderListItem provider={provider} />
              </li>
            ))
          }
        </ul>
      </BaseCardBody>
    </BaseCard>
  );
};

ServiceProvidersList.propTypes = {
  providers: PropTypes.array,
  header: PropTypes.string.isRequired,
};

ServiceProvidersList.defaultProps = {
  providers: [],
};

export default ServiceProvidersList;
